import {
  getInternalMaterialProductName,
  isObject,
  type MaterialProductInfoListItem,
  useApiMaterialV1MaterialProductsList,
} from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialAutocompleteProps = {
  country?: string;
  material_grade_id?: number;
  material_spec_id?: number;
} & Omit<AutocompleteFieldProps<MaterialProductInfoListItem>, 'options'>;

export const MaterialProductAutocomplete = ({
  country,
  material_grade_id,
  material_spec_id,
  ...props
}: MaterialAutocompleteProps) => {
  const { data, isLoading } = useApiMaterialV1MaterialProductsList({
    country,
    material_grade_id,
    material_spec_id,
    page_size: 100,
  });

  return (
    <AutocompleteField<MaterialProductInfoListItem>
      {...props}
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option)) {
          return getInternalMaterialProductName(option);
        }
        return '';
      }}
      filterOptions={(options, state) =>
        options.filter((option) =>
          getInternalMaterialProductName(option).toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
      valueField="id"
      data-testid="material-product-autocomplete"
    />
  );
};
